import parse from "html-react-parser";
import styles from "./DetailPopup.module.scss";
import { useRef } from "react";
import { Close } from "components/assets/Icons";
import UserInfo from "components/UserInfo";
import { getMonthName, padTo2Digits } from "utils/modifyDate";
import { getZonedTime, SYSTEM_TIMEZONE } from "utils/trackingTransform";
import { removeUnnecessaryData } from "pages/Tracking/utils";

const DetailPopup = ({ setShowDetailPopup, popupDetails, timezone = SYSTEM_TIMEZONE }) => {
  const ref = useRef();
  const { photoUrl, firstName, lastName, sent_date } = popupDetails || {};
  const date = new Date(sent_date);

  const closeHandler = () => {
    setShowDetailPopup(false);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container} ref={ref}>
        <span className={styles.close} onClick={closeHandler}>
          <Close />
        </span>
        <div className={styles.content}>
          <div className={styles.header}>
            <div className={styles.user}>
              {photoUrl && (
                <UserInfo src={photoUrl} name={`${firstName} ${lastName}`} />
              )}
            </div>
            <div className={styles.date}>{`${getMonthName(
              date,
              "long"
            )} ${padTo2Digits(
              date.getDate()
            )}, ${date.getFullYear()}, ${getZonedTime(sent_date, timezone)}`}</div>
          </div>
          <div className={styles.body}>
            <div className={styles.table}>
              <span className={styles.label}>From</span>
              <span>{removeUnnecessaryData(popupDetails?.email_from)}</span>

              <span className={styles.label}>To</span>
              <span>{removeUnnecessaryData(popupDetails?.email_to)}</span>

              <span className={styles.label}>CC</span>
              <span>{removeUnnecessaryData(popupDetails?.email_cc)}</span>

              <span className={styles.label}>BCC</span>
              <span>{popupDetails?.email_bcc}</span>

              <span className={styles.label}>Subject</span>
              <span>{removeUnnecessaryData(popupDetails?.subject)}</span>
            </div>

            {parse(popupDetails?.message_text)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPopup;
